import { Component, Input, OnInit } from '@angular/core';
import { PersonalInfoService } from '../../services/personal-info.service';
import { BasicInfoService } from '../../services/basic-info.service';
import { environment } from 'src/environments/local/environment';
import { Countries } from 'src/app/app.consts';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss'],
})
export class PersonalInfoComponent implements OnInit {
  isFinland = environment.country === Countries.FINLAND;
  @Input() isSummary = false;

  constructor(
    public personalInfoService: PersonalInfoService,
    public basicInfoService: BasicInfoService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {}
}
